
// // client/src/components/media/MediaPost.jsx
// import React, { useMemo, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import { FaTimes, FaPaperPlane, FaArrowLeft } from "react-icons/fa";
// import PlatformSelector from '../PlatformSelector';

// function baseUrlFromReq(req) {
//   const envBase = (process.env.INTEGRATIONS_BASE_URL || process.env.BASE_URL || process.env.APP_URL || '').replace(/\/+$/, '');
//   if (envBase) return envBase;
//   const proto = (req.headers['x-forwarded-proto'] || req.protocol || 'https');
//   const host  = req.headers['x-forwarded-host'] || req.get('host');
//   return `${proto}://${host}`;
// }

// const IMG_EXT = new Set(['jpg','jpeg','png','gif','webp']);
// const VID_EXT = new Set(['mp4','mov','webm','mkv']);
// const extOf = (u='') => { try { return new URL(u).pathname.split('.').pop().toLowerCase(); } catch { return ''; } };


// // ---- helpers ---------------------------------------------------------------
// const isImageUrl = (u = "") => {
//   const clean = String(u).split("?")[0];
//   const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
//   return ["jpg", "jpeg", "png", "gif", "webp", "heic", "avif"].includes(ext);
// };

// const isVideoUrl = (u = "") => {
//   const clean = String(u).split("?")[0];
//   const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
//   return ["mp4", "m4v", "mov", "webm", "mkv"].includes(ext);
// };

// const detectKind = (urls = []) => {
//   const first = (urls[0] || "").toLowerCase().split("?")[0];
//   if (/\.(mp4|m4v)$/.test(first)) return "video";
//   if (/\.(mov|qt)$/.test(first))  return "mov";
//   if (/\.(jpg|jpeg|png|gif|webp|heic|avif)$/.test(first)) return "image";
//   return "";
// };

// // Treat absolute https://on-screen.app/public/... and relative /public/... as local
// const isLocalPublic = (u, base) => {
//   try {
//     const root = String(base).replace(/\/+$/, "");
//     const abs  = /^https?:\/\//i.test(String(u)) ? String(u) : `${root}/${String(u).replace(/^\/+/, "")}`;
//     const url  = new URL(abs);
//     return url.pathname.startsWith("/public/");
//   } catch { return false; }
// };

// export default function MediaPost() {
//   const { tenant, eventId, itemId } = useParams();
//   const { state } = useLocation();
//   const navigate = useNavigate();

//   const baseUrl =
//     process.env.REACT_APP_BASE_URL ||
//     window.location.origin ||
//     "http://localhost:5000";

//   // Normalize to absolute, publicly reachable URL (needed for IG/Bluesky/preview)
//   const toPublic = (u) => {
//     if (!u) return u;
//     const root = String(baseUrl).replace(/\/+$/, "");
//     if (/^https?:\/\//i.test(u)) return u;
//     if (u.startsWith("/public/")) return `${root}${u}`;
//     if (u.startsWith("/tenants/")) return `${root}/public${u}`;
//     // ensure spaces/utf8 are encoded
//     const combined = `${root}/${String(u).replace(/^\/+/, "")}`;
//     return encodeURI(combined);
//   };

//   // Convert an absolute/public path back to a server file path under /public
//   // (required by /api/youtube/upload which expects a local server path)
//   const toServerFilePath = (u) => {
//     if (!u) return null;
//     let pathname = u;
//     try {
//       if (/^https?:\/\//i.test(u)) {
//         const url = new URL(u);
//         pathname = url.pathname; // keep only the local path
//       }
//     } catch { /* leave pathname as-is */ }
//     if (pathname.startsWith("/tenants/")) pathname = `/public${pathname}`;
//     if (pathname.startsWith("/public/")) return pathname;
//     // Fallback: not a local asset (skip for YouTube uploads)
//     return null;
//   };

//   // ---------------- incoming defaults ----------------
//   const defaultText =
//     state?.content || state?.caption || state?.title || state?.description || "";

//   // Accept multiple shapes that upstream screens send
//   const fromStateImages =
//     (Array.isArray(state?.images) && state.images) ||
//     (Array.isArray(state?.media) && state.media) ||
//     (Array.isArray(state?.selectedMedia?.images) && state.selectedMedia.images) ||
//     (Array.isArray(state?.media?.images) && state.media.images) ||
//     [];

//   const fromStateVideos =
//     (Array.isArray(state?.videos) && state.videos) ||
//     (Array.isArray(state?.selectedMedia?.videos) && state.selectedMedia.videos) ||
//     (Array.isArray(state?.media?.videos) && state.media.videos) ||
//     [];

//   // Keep original order, unique
//   const unique = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

//   const imagesRaw = useMemo(() => unique(fromStateImages), [fromStateImages]);
//   const videosRaw = useMemo(() => unique(fromStateVideos), [fromStateVideos]);

//   // Make absolute for posting/preview
//   const imagesAbsAll = useMemo(() => imagesRaw.map(toPublic), [imagesRaw]);
//   const videosAbs    = useMemo(() => videosRaw.map(toPublic), [videosRaw]);

//   // Strictly filter images for the "Images" section to avoid broken overlay on videos
//   const imagesAbs = useMemo(() => imagesAbsAll.filter(isImageUrl), [imagesAbsAll]);

//   // Server file paths for YouTube upload (local /public/... only)
//   const youtubeFilePaths = useMemo(
//     () => videosAbs.map(toServerFilePath).filter(Boolean),
//     [videosAbs]
//   );

//   // Bluesky supports images only (max 4)
//   const blueskyImages = useMemo(
//     () => imagesAbs.filter(isImageUrl).slice(0, 4),
//     [imagesAbs]
//   );

//   // ---------------- local state ----------------
//   const [content, setContent] = useState(defaultText);
//   const [busy, setBusy]       = useState(false);
//   const [error, setError]     = useState("");

//   // Default toggles preserved
//   const [platforms, setPlatforms] = useState({
//     instagram: false,
//     facebook:  false,
//     twitter:   false,
//     linkedin:  false,
//     bluesky:   false,
//     youtube:   false,
//     tiktok:    false,
//   });

//   const selected = useMemo(
//     () => Object.entries(platforms).filter(([, v]) => v).map(([k]) => k),
//     [platforms]
//   );

//   // ---------------- actions ----------------
//   const openBlueskyConnect = () => {
//     const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${Number(tenant || 1)}`;
//     window.open(url, "bsky-connect", "width=520,height=520,menubar=no,toolbar=no");
//   };

//   const ensureIgReady = async (tenantId) => {
//     const safeFetch = async (url) => {
//       try { const r = await fetch(url, { credentials: "include" }); return r.ok ? r.json() : null; }
//       catch { return null; }
//     };
//     const fbPeek = await safeFetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
//     let pages = Array.isArray(fbPeek?.pages) ? fbPeek.pages : [];
//     if (!pages.length) {
//       const igPeek = await safeFetch(`${baseUrl}/api/integrations/instagram/_peek?tenantId=${tenantId}`);
//       pages = Array.isArray(igPeek?.pages) ? igPeek.pages : [];
//     }
//     const eligible = pages.some((p) => p?.igUserId && (p?.hasPageToken || p?.pageToken));
//     if (!eligible) {
//       throw new Error(
//         "No connected Facebook/IG account for tenant. Go to Integrations → Facebook/Instagram and connect a Page linked to your IG."
//       );
//     }
//   };

//   const uploadToYouTube = async (tenantId) => {
//     if (!youtubeFilePaths.length) {
//       throw new Error("YouTube requires at least one local video under /public.");
//     }
//     const title = (content || "Upload").slice(0, 95);
//     const description = content || "";
//     for (const filePath of youtubeFilePaths) {
//       await axios.post(
//         `${baseUrl}/api/youtube/upload`,
//         { tenantId, title, description, privacyStatus: "unlisted", filePath },
//         { withCredentials: true, timeout: 5 * 60 * 1000 }
//       );
//     }
//   };

//   // --- helper: publish to Twitter directly (no backend file additions) ----
//   const publishToTwitter = async (tenantId, text, mediaUrls) => {
//     // Split into imageUrls / videoUrls using current URL helpers
//     const imageUrls = (mediaUrls || []).filter(isImageUrl);
//     const videoUrls = (mediaUrls || []).filter(isVideoUrl);

//     // Prefer unified Twitter publish; fallback to /tweet if not present
//     const paths = [
//       "/api/integrations/twitter/publish",
//       "/api/integrations/twitter/tweet",
//     ];

//     let lastErr, rsp;
//     for (const p of paths) {
//       try {
//         rsp = await axios.post(
//           `${baseUrl}${p}`,
//           { tenantId, text, imageUrls, videoUrls },
//           { withCredentials: true, timeout: 120000 }
//         );
//         break;
//       } catch (e) {
//         lastErr = e;
//       }
//     }
//     if (!rsp) {
//       const detail =
//         lastErr?.response?.data?.error ||
//         lastErr?.response?.data ||
//         lastErr?.message ||
//         "twitter publish failed";
//       throw new Error(
//         typeof detail === "string" ? detail : JSON.stringify(detail)
//       );
//     }
//     return rsp.data;
//   };

//   /**
//    * Post to LinkedIn
//    * Chooses appropriate endpoint based on media type
//    */
//   const postToLinkedIn = async () => {
//     const tenantId = Number(tenant);
//     const text = (content || '').trim();

//     const hasVideo = videosAbs.length > 0;
//     const hasImage = imagesAbs.length > 0;

//     // Video takes precedence
//     if (hasVideo) {
//       const videoUrl = videosAbs[0]; // Use first video
//       return axios.post(
//         `${baseUrl}/api/integrations/linkedin/publish-with-video`,
//         {
//           tenantId,
//           text,
//           videoUrl,
//           as: 'member' // Change to 'organization' when org posting is approved
//         },
//         { withCredentials: true, timeout: 60000 }
//       );
//     }

//     // Image if no video
//     if (hasImage) {
//       const imageUrl = imagesAbs[0]; // Use first image
//       return axios.post(
//         `${baseUrl}/api/integrations/linkedin/publish-with-image`,
//         {
//           tenantId,
//           text,
//           imageUrl,
//           as: 'member' // Change to 'organization' when org posting is approved
//         },
//         { withCredentials: true, timeout: 60000 }
//       );
//     }

//     // Text only
//     return axios.post(
//       `${baseUrl}/api/integrations/linkedin/publish`,
//       {
//         tenantId,
//         text,
//         as: 'member' // Change to 'organization' when org posting is approved
//       },
//       { withCredentials: true, timeout: 60000 }
//     );
//   };

//   /**
//    * Post to TikTok
//    * Sends video or image to TikTok as draft (Upload mode) or posts directly
//    */
//   const postToTikTok = async () => {
//     const tenantId = Number(tenant);
//     const caption = (content || '').trim();
    
//     // TikTok supports both video and images
//     const hasVideo = videosAbs.length > 0;
//     const hasImage = imagesAbs.length > 0;
    
//     if (!hasVideo && !hasImage && !caption) {
//       throw new Error('TikTok requires at least a video, image, or caption.');
//     }
    
//     // Use first video if available, otherwise first image
//     const mediaUrl = hasVideo ? videosAbs[0] : (hasImage ? imagesAbs[0] : null);
    
//     if (!mediaUrl) {
//       throw new Error('TikTok requires at least one video or image.');
//     }
    
//     return axios.post(
//       `${baseUrl}/api/integrations/tiktok/publish`,
//       {
//         tenantId,
//         mediaUrl,
//         caption,
//         mode: 'upload' // Send to TikTok Inbox as draft
//       },
//       { withCredentials: true, timeout: 60000 }
//     );
//   };

//   const submit = async () => {
//     try {
//       setBusy(true);
//       setError("");

//       if (!selected.length) throw new Error("Select at least one platform.");

//       const tenantId = Number(tenant) || 1;

//       // Build common payload for your hub route (others can accept video)
//       const mediaUrlsForOthers = unique([...videosAbs, ...imagesAbs]);

//       // Detect on what we actually send
//       const detected = detectKind(mediaUrlsForOthers);

//       // Map kind → backend expectations
//       const inferredKind =
//         detected === "video" ? "reel" :
//         detected === "image" ? "image" : "";

//       // Instagram validations (format & connection)
//       if (platforms.instagram) {
//         await ensureIgReady(tenantId);

//         // Only block MOV if it's NOT a local /public/... asset (server auto-transcodes locals)
//         if (detected === "mov") {
//           const first = mediaUrlsForOthers[0] || "";
//           if (!isLocalPublic(first, baseUrl)) {
//             throw new Error(
//               "Instagram only accepts MP4 (H.264 + AAC). Convert your MOV to MP4 or upload it to this app (under /public) so we can auto-convert."
//             );
//           }
//           // local MOV → allowed; backend will transcode
//         }

//         if (!mediaUrlsForOthers.length && !content.trim()) {
//           throw new Error("Instagram requires at least one image/video or a caption.");
//         }
//       }

//       // If multiple images selected, pass a simple carouselItems list
//       const igCarousel = imagesAbs.length > 1
//         ? imagesAbs.slice(0, 10).map((u) => ({ imageUrl: u }))
//         : undefined;

//       // Remove twitter and linkedin from the hub list (we'll call them directly)
//       const platformsForHub = selected.filter(
//         (p) => p !== "bluesky" && p !== "youtube" && p !== "twitter" && p !== "linkedin" && p !== "tiktok"
//       );

//       const payloadCommon = {
//         tenantId,
//         eventId:    eventId ? Number(eventId) : null,
//         eventItemId:itemId ? Number(itemId) : null,
//         platforms:  platformsForHub,
//         content,                    // keep for your other routes
//         caption: content,           // ensure instagramGraph receives caption text
//         mediaUrls: mediaUrlsForOthers,
//         kind: inferredKind,         // 'reel' | 'image' | '' (server also infers)
//         shareToFeed: true,
//         thumbOffsetSec: 0,
//         carouselItems: igCarousel,
//       };

//       // 1) Others via hub
//       if (payloadCommon.platforms.length) {
//         await axios.post(`${baseUrl}/api/integrations/publish`, payloadCommon, {
//           withCredentials: true,
//           timeout: 120000,
//         });
//       }

//       // 2) Twitter directly (bypasses generic hub to avoid "Platform not implemented")
//       if (platforms.twitter) {
//         await publishToTwitter(tenantId, content || "", mediaUrlsForOthers);
//       }

//       // 3) LinkedIn directly
//       if (platforms.linkedin) {
//         await postToLinkedIn();
//       }

//       // 4) YouTube (videos only, uses server file paths)
//       if (platforms.youtube) {
//         await uploadToYouTube(tenantId);
//       }

//       // 5) Bluesky (images only, up to 4)
//       if (platforms.bluesky) {
//         if (!content.trim() && blueskyImages.length === 0) {
//           throw new Error("Bluesky requires text or at least one image (video is not supported).");
//         }
//         await axios.post(
//           `${baseUrl}/api/integrations/bluesky/publish`,
//           { tenantId, text: content || "", mediaUrls: blueskyImages },
//           { withCredentials: true, timeout: 60000 }
//         );
//       }

//       // 6) TikTok (video or image to draft Inbox)
//       if (platforms.tiktok) {
//         await postToTikTok();
//       }

//       navigate(-1);
//     } catch (e) {
//       const msg =
//         e?.response?.data?.message ||
//         e?.response?.data?.error ||
//         e.message ||
//         "Failed to post";
//       setError(msg);
//     } finally {
//       setBusy(false);
//     }
//   };

//   const canSubmit =
//     selected.length > 0 &&
//     (content.trim().length > 0 || imagesAbs.length > 0 || videosAbs.length > 0);

//   // ---------------- render ----------------
//   return (
//     <div className="container py-3">
//       <h4 className="mb-3">Create Media Post</h4>

//       {/* Integrations - Dropdown Selector */}
//       <div className="mb-3">
//         <div className="form-label font-semibold mb-2">Select Integrations</div>
//         <PlatformSelector
//           platforms={platforms}
//           setPlatforms={setPlatforms}
//           onConnect={(platformKey) => {
//             if (platformKey === 'bluesky') {
//               openBlueskyConnect();
//             }
//           }}
//           showConnectFor={['bluesky']}
//         />
//       </div>

//       {/* Content */}
//       <div className="mb-3">
//         <label className="form-label">Post Content</label>
//         <textarea
//           className="form-control"
//           rows={5}
//           value={content}
//           onChange={(e) => setContent(e.target.value)}
//         />
//       </div>

//       {/* Images */}
//       <div className="mb-3">
//         <div className="form-label">Images:</div>

//         {imagesAbs.length === 0 ? (
//           <div className="text-gray-400">No images provided.</div>
//         ) : (
//           <>
//             {/* HERO (full-width, responsive) */}
//             <div
//               className="border rounded mb-2"
//               style={{
//                 width: "100%",
//                 maxWidth: "100%",
//                 background: "#111",
//                 overflow: "hidden",
//               }}
//             >
//               <img
//                 src={imagesAbs[0]}
//                 alt=""
//                 style={{
//                   width: "100%",
//                   height: "auto",
//                   display: "block",
//                   objectFit: "contain",
//                 }}
//                 onError={(e) => (e.currentTarget.src = "/event.png")}
//               />
//             </div>

//             {/* Thumbnails (if more than one) */}
//             {imagesAbs.length > 1 && (
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns:
//                     "repeat(auto-fill, minmax(160px, 1fr))",
//                   gap: 10,
//                 }}
//               >
//                 {imagesAbs.slice(1).map((u, i) => (
//                   <div
//                     key={i}
//                     className="border rounded overflow-hidden"
//                     style={{ aspectRatio: "4 / 3", background: "#111" }}
//                   >
//                     <img
//                       src={u}
//                       alt=""
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                       onError={(e) => (e.currentTarget.src = "/event.png")}
//                     />
//                   </div>
//                 ))}
//               </div>
//             )}
//           </>
//         )}

//         {/* Bluesky hint */}
//         {platforms.bluesky && blueskyImages.length === 0 && !content.trim() && (
//           <div className="form-text mt-2">
//             Bluesky supports images (no video). Add at least one image or include
//             text.
//           </div>
//         )}
//       </div>

//       {/* Videos */}
//       {!!videosAbs.length && (
//         <div className="mb-3">
//           {/* <div className="form-label">
//             Videos (for Instagram/Twitter/LinkedIn/YouTube):
//           </div>
//           <div className="text-gray-400" style={{ fontSize: 13 }}>
//             YouTube uploads require local files under <code>/public</code>.
//             External URLs are skipped.
//           </div> */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
//               gap: 12,
//               marginTop: 8,
//             }}
//           >
//             {videosAbs.map((u, i) => (
//               <video key={i} src={u} controls style={{ width: "100%" }} />
//             ))}
//           </div>
//         </div>
//       )}

//       {!!error && <div className="alert alert-danger">{error}</div>}

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           {
//             icon: <FaPaperPlane />,
//             label: busy ? "Posting…" : "Submit",
//             onClick: submit,
//             disabled: busy || !canSubmit,
//             type: "submit",
//           },
//         ]}
//       />
//     </div>
//   );
// }

// client/src/components/media/MediaPost.jsx
import React, { useMemo, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import AppFooter from "../AppFooter";
import { FaPaperPlane, FaArrowLeft, FaEdit, FaSpinner, FaMusic, FaFilm } from "react-icons/fa";
import PlatformSelector from '../PlatformSelector';
import MediaEditor from './MediaEditor';
import MentionInput from './MentionInput';
import MediaTagOverlay, { FullSizeMediaModal } from './MediaTagOverlay';
import MusicPicker from './MusicPicker';
import { api as apiClient } from '../../api/client';

// ---- helpers ---------------------------------------------------------------
const isImageUrl = (u = "") => {
  const clean = String(u).split("?")[0];
  const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
  return ["jpg", "jpeg", "png", "gif", "webp", "heic", "avif"].includes(ext);
};

const isVideoUrl = (u = "") => {
  const clean = String(u).split("?")[0];
  const ext = clean.includes(".") ? clean.split(".").pop().toLowerCase() : "";
  return ["mp4", "m4v", "mov", "webm", "mkv"].includes(ext);
};

const detectKind = (urls = []) => {
  const first = (urls[0] || "").toLowerCase().split("?")[0];
  if (/\.(mp4|m4v)$/.test(first)) return "video";
  if (/\.(mov|qt)$/.test(first))  return "mov";
  if (/\.(jpg|jpeg|png|gif|webp|heic|avif)$/.test(first)) return "image";
  return "";
};

// Treat absolute https://on-screen.app/public/... and relative /public/... as local
const isLocalPublic = (u, base) => {
  try {
    const root = String(base).replace(/\/+$/, "");
    const abs  = /^https?:\/\//i.test(String(u)) ? String(u) : `${root}/${String(u).replace(/^\/+/, "")}`;
    const url  = new URL(abs);
    return url.pathname.startsWith("/public/");
  } catch { return false; }
};

export default function MediaPost() {
  const { tenant, eventId, itemId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const baseUrl =
    process.env.REACT_APP_BASE_URL ||
    window.location.origin ||
    "http://localhost:5000";

  // Normalize to absolute, publicly reachable URL (needed for IG/Bluesky/preview)
  const toPublic = (u) => {
    if (!u) return u;
    const root = String(baseUrl).replace(/\/+$/, "");
    if (/^https?:\/\//i.test(u)) return u;
    if (u.startsWith("/public/")) return `${root}${u}`;
    if (u.startsWith("/tenants/")) return `${root}/public${u}`;
    // ensure spaces/utf8 are encoded
    const combined = `${root}/${String(u).replace(/^\/+/, "")}`;
    return encodeURI(combined);
  };

  // Convert an absolute/public path back to a server file path under /public
  // (required by /api/youtube/upload which expects a local server path)
  const toServerFilePath = (u) => {
    if (!u) return null;
    let pathname = u;
    try {
      if (/^https?:\/\//i.test(u)) {
        const url = new URL(u);
        pathname = url.pathname; // keep only the local path
      }
    } catch { /* leave pathname as-is */ }
    if (pathname.startsWith("/tenants/")) pathname = `/public${pathname}`;
    if (pathname.startsWith("/public/")) return pathname;
    // Fallback: not a local asset (skip for YouTube uploads)
    return null;
  };

  // ---------------- incoming defaults ----------------
  const defaultText =
    state?.content || state?.caption || state?.title || state?.description || "";

  // Accept multiple shapes that upstream screens send
  const fromStateImages =
    (Array.isArray(state?.images) && state.images) ||
    (Array.isArray(state?.media) && state.media) ||
    (Array.isArray(state?.selectedMedia?.images) && state.selectedMedia.images) ||
    (Array.isArray(state?.media?.images) && state.media.images) ||
    [];

  const fromStateVideos =
    (Array.isArray(state?.videos) && state.videos) ||
    (Array.isArray(state?.selectedMedia?.videos) && state.selectedMedia.videos) ||
    (Array.isArray(state?.media?.videos) && state.media.videos) ||
    [];

  // Keep original order, unique
  const unique = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

  const imagesRaw = useMemo(() => unique(fromStateImages), [fromStateImages]);
  const videosRaw = useMemo(() => unique(fromStateVideos), [fromStateVideos]);

  // Make absolute for posting/preview
  const imagesAbsAll = useMemo(() => imagesRaw.map(toPublic), [imagesRaw]);
  const videosAbs    = useMemo(() => videosRaw.map(toPublic), [videosRaw]);

  // Strictly filter images for the "Images" section to avoid broken overlay on videos
  const imagesAbs = useMemo(() => imagesAbsAll.filter(isImageUrl), [imagesAbsAll]);

  // Server file paths for YouTube upload (local /public/... only)
  const youtubeFilePaths = useMemo(
    () => videosAbs.map(toServerFilePath).filter(Boolean),
    [videosAbs]
  );

  // ---------------- local state ----------------
  const [content, setContent] = useState(defaultText);
  const [busy, setBusy]       = useState(false);
  const [error, setError]     = useState("");

  // Image editor state
  const [editingImageIdx, setEditingImageIdx] = useState(null);
  const [editedImages, setEditedImages] = useState([]);

  // User tags on media (per image index): { [imageIdx]: [{ username, x, y }] }
  const [userTags, setUserTags] = useState({});

  // Index of image currently shown full-size for tagging. null = closed.
  const [fullSizeImgIdx, setFullSizeImgIdx] = useState(null);

  // Image-to-video: when set, the rendered slideshow MP4 replaces images for
  // posting so platforms like TikTok/IG-Reels/YouTube-Shorts have a video to
  // consume. Setting back to null restores image posting.
  const [convertingToVideo, setConvertingToVideo] = useState(false);
  const [generatedVideoUrl, setGeneratedVideoUrl] = useState(null);
  const [imgToVideoSeconds, setImgToVideoSeconds] = useState(4);
  const handleConvertToVideo = async () => {
    setConvertingToVideo(true);
    setError("");
    try {
      const { data } = await axios.post(
        `/api/media/image-to-video`,
        { imageUrls: effectiveImages, secondsPerImage: imgToVideoSeconds },
        { withCredentials: true, timeout: 180000 }
      );
      if (!data?.ok || !data?.url) throw new Error(data?.error || 'Conversion failed');
      setGeneratedVideoUrl(data.url);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Conversion failed');
    } finally {
      setConvertingToVideo(false);
    }
  };
  const handleRevertToImages = () => {
    setGeneratedVideoUrl(null);
  };

  // Effective images: use edited replacements where available
  const effectiveImages = useMemo(() =>
    imagesAbs.map((url, i) => editedImages[i] || url),
    [imagesAbs, editedImages]
  );

  // Bluesky supports images only (max 4)
  const blueskyImages = useMemo(
    () => effectiveImages.filter(isImageUrl).slice(0, 4),
    [effectiveImages]
  );

  // Default toggles preserved
  const [platforms, setPlatforms] = useState({
    instagram: false,
    facebook:  false,
    twitter:   false,
    linkedin:  false,
    bluesky:   false,
    threads:   false,
    youtube:   false,
    tiktok:    false,
    reddit:    false,
  });

  // Music-on-posts state. draftRef is a stable client-side id so the server
  // can re-locate the t_post_music row when the post is later scheduled.
  const musicDraftRef = useRef(`draft_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`);
  const [musicPickerOpen, setMusicPickerOpen] = useState(false);
  const [musicAttachment, setMusicAttachment] = useState(null);
  const handleMusicAttached = ({ attachmentId, track, tiktokUseNativeSound }) => {
    setMusicAttachment({ id: attachmentId, track, tiktokUseNativeSound, status: tiktokUseNativeSound ? 'ready' : 'pending' });
  };
  const removeMusic = async () => {
    if (!musicAttachment?.id) { setMusicAttachment(null); return; }
    try { await apiClient.delete(`/music/attachment/${musicAttachment.id}`); } catch (err) { console.warn('removeMusic failed', err); }
    setMusicAttachment(null);
  };

  // Instagram/Facebook Reel options. `igPostKind` is 'auto' | 'reel' | 'feed'.
  // 'auto' = extension-driven (mp4 → reel, image → feed). 'reel'/'feed' force
  // the intent for both IG and (if FB checked) the linked FB Page publish path.
  const [igPostKind, setIgPostKind] = useState('auto');
  const [igShareReelToFeed, setIgShareReelToFeed] = useState(true);

  // Reddit-specific state
  const [redditSubreddits, setRedditSubreddits] = useState([]);
  const [redditSubreddit, setRedditSubreddit] = useState('');
  const [redditTitle, setRedditTitle] = useState('');

  // TikTok Direct Post state
  const [tiktokMode, setTiktokMode] = useState('upload');
  const [tiktokTitle, setTiktokTitle] = useState(''); // Point 2a: Title field
  const [tiktokPrivacy, setTiktokPrivacy] = useState(''); // No default per TikTok guidelines
  const [tiktokDisableDuet, setTiktokDisableDuet] = useState(true); // Unchecked by default per guidelines
  const [tiktokDisableStitch, setTiktokDisableStitch] = useState(true);
  const [tiktokDisableComment, setTiktokDisableComment] = useState(true);
  const [tiktokIsDirect, setTiktokIsDirect] = useState(false);
  const [tiktokCreator, setTiktokCreator] = useState(null); // Creator info from API
  const [tiktokCommercialToggle, setTiktokCommercialToggle] = useState(false);
  const [tiktokBrandOrganic, setTiktokBrandOrganic] = useState(false); // "Your Brand"
  const [tiktokBrandContent, setTiktokBrandContent] = useState(false); // "Branded Content"
  const [tiktokPostStatus, setTiktokPostStatus] = useState(null); // Point 5e: publish status tracking

  const selected = useMemo(
    () => Object.entries(platforms).filter(([, v]) => v).map(([k]) => k),
    [platforms]
  );

  // Fetch Reddit subreddits when Reddit is toggled on
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => {
    if (platforms.reddit && redditSubreddits.length === 0) {
      const tenantId = Number(tenant) || 1;
      fetch(`${baseUrl}/api/integrations/reddit/subreddits?tenantId=${tenantId}`)
        .then(r => r.json())
        .then(data => {
          if (data.success && data.items) setRedditSubreddits(data.items);
        })
        .catch(err => console.error('Failed to fetch subreddits:', err));
    }
  }, [platforms.reddit]);

  // Check TikTok status and fetch creator info when TikTok is toggled on
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => {
    if (platforms.tiktok) {
      const tenantId = Number(tenant) || 1;
      // Check connection status
      fetch(`${baseUrl}/api/integrations/tiktok/status?tenantId=${tenantId}`)
        .then(r => r.json())
        .then(data => {
          const hasDirect = data.connected && data.isDirect;
          setTiktokIsDirect(hasDirect);
          if (!hasDirect) setTiktokMode('upload');
          // Fetch creator info (required by TikTok every time post page renders)
          if (hasDirect) {
            fetch(`${baseUrl}/api/integrations/tiktok/creator-info?tenantId=${tenantId}`)
              .then(r => r.json())
              .then(ci => {
                if (ci.success && ci.creator) setTiktokCreator(ci.creator);
              })
              .catch(err => console.error('Failed to fetch TikTok creator info:', err));
          }
        })
        .catch(err => console.error('Failed to check TikTok status:', err));
    }
  }, [platforms.tiktok]);

  // ---------------- actions ----------------
  const openBlueskyConnect = () => {
    const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${Number(tenant || 1)}`;
    window.open(url, "bsky-connect", "width=520,height=520,menubar=no,toolbar=no");
  };

  const ensureIgReady = async (tenantId) => {
    const safeFetch = async (url) => {
      try { const r = await fetch(url, { credentials: "include" }); return r.ok ? r.json() : null; }
      catch { return null; }
    };
    // Check BOTH peek endpoints. FB peek lists Facebook Pages (which may or may
    // not have a linked IG account); IG _peek also includes Instagram Business
    // Login connections that don't go through a Facebook Page. Merge both so
    // either path counts as eligible.
    const [fbPeek, igPeek] = await Promise.all([
      safeFetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`),
      safeFetch(`${baseUrl}/api/integrations/instagram/_peek?tenantId=${tenantId}`),
    ]);
    const pages = [
      ...(Array.isArray(fbPeek?.pages) ? fbPeek.pages : []),
      ...(Array.isArray(igPeek?.pages) ? igPeek.pages : []),
    ];
    const eligible = pages.some((p) => p?.igUserId && (p?.hasPageToken || p?.pageToken));
    if (!eligible) {
      throw new Error(
        "No connected Facebook/IG account for tenant. Go to Integrations → Facebook/Instagram and connect a Page linked to your IG."
      );
    }
  };

  const uploadToYouTube = async (tenantId) => {
    // An image-to-video conversion result lives under /public just like an
    // uploaded video, but it isn't part of youtubeFilePaths (derived from the
    // original media state). Include it — run through the same
    // toPublic→toServerFilePath pipeline — so image-only posts converted to a
    // slideshow MP4 can still publish to YouTube. Mirrors mediaUrlsForOthers.
    const generatedPath = toServerFilePath(toPublic(generatedVideoUrl));
    const filePaths = unique([
      ...(generatedPath ? [generatedPath] : []),
      ...youtubeFilePaths,
    ]);
    if (!filePaths.length) {
      throw new Error("YouTube requires at least one local video under /public.");
    }
    const title = (content || "Upload").slice(0, 95);
    const description = content || "";
    for (const filePath of filePaths) {
      await axios.post(
        `${baseUrl}/api/youtube/upload`,
        { tenantId, title, description, privacyStatus: "unlisted", filePath },
        { withCredentials: true, timeout: 5 * 60 * 1000 }
      );
    }
  };

  // --- helper: publish to Twitter directly (no backend file additions) ----
  const publishToTwitter = async (tenantId, text, mediaUrls) => {
    // Split into imageUrls / videoUrls using current URL helpers
    const imageUrls = (mediaUrls || []).filter(isImageUrl);
    const videoUrls = (mediaUrls || []).filter(isVideoUrl);

    // Prefer unified Twitter publish; fallback to /tweet if not present
    const paths = [
      "/api/integrations/twitter/publish",
      "/api/integrations/twitter/tweet",
    ];

    let lastErr, rsp;
    for (const p of paths) {
      try {
        rsp = await axios.post(
          `${baseUrl}${p}`,
          { tenantId, text, imageUrls, videoUrls },
          { withCredentials: true, timeout: 120000 }
        );
        break;
      } catch (e) {
        lastErr = e;
      }
    }
    if (!rsp) {
      const detail =
        lastErr?.response?.data?.error ||
        lastErr?.response?.data ||
        lastErr?.message ||
        "twitter publish failed";
      throw new Error(
        typeof detail === "string" ? detail : JSON.stringify(detail)
      );
    }
    return rsp.data;
  };

  /**
   * Post to LinkedIn
   * Chooses appropriate endpoint based on media type
   */
  const postToLinkedIn = async () => {
    const tenantId = Number(tenant);
    const text = (content || '').trim();

    const hasVideo = videosAbs.length > 0;
    const hasImage = imagesAbs.length > 0;

    // Video takes precedence
    if (hasVideo) {
      const videoUrl = videosAbs[0]; // Use first video
      return axios.post(
        `${baseUrl}/api/integrations/linkedin/publish-with-video`,
        {
          tenantId,
          text,
          videoUrl,
          as: 'member' // Change to 'organization' when org posting is approved
        },
        { withCredentials: true, timeout: 60000 }
      );
    }

    // Image if no video
    if (hasImage) {
      const imageUrl = imagesAbs[0]; // Use first image
      return axios.post(
        `${baseUrl}/api/integrations/linkedin/publish-with-image`,
        {
          tenantId,
          text,
          imageUrl,
          as: 'member' // Change to 'organization' when org posting is approved
        },
        { withCredentials: true, timeout: 60000 }
      );
    }

    // Text only
    return axios.post(
      `${baseUrl}/api/integrations/linkedin/publish`,
      {
        tenantId,
        text,
        as: 'member' // Change to 'organization' when org posting is approved
      },
      { withCredentials: true, timeout: 60000 }
    );
  };

  /**
   * Post to TikTok
   * Sends video or image to TikTok as draft (Upload mode) or posts directly
   */
  const postToTikTok = async () => {
    const tenantId = Number(tenant);
    const caption = (content || '').trim();
    
    // TikTok supports both video and images
    const hasVideo = videosAbs.length > 0;
    const hasImage = imagesAbs.length > 0;
    
    if (!hasVideo && !hasImage && !caption) {
      throw new Error('TikTok requires at least a video, image, or caption.');
    }
    
    // Use first video if available, otherwise first image
    const mediaUrl = hasVideo ? videosAbs[0] : (hasImage ? imagesAbs[0] : null);
    
    if (!mediaUrl) {
      throw new Error('TikTok requires at least one video or image.');
    }
    
    // For videos, optionally include a cover image (first available image)
    // This helps meet TikTok's picture_size_check requirements
    const coverImageUrl = hasVideo && imagesAbs.length > 0 ? imagesAbs[0] : null;
    
    const body = {
      tenantId,
      mediaUrl,
      caption,
      title: tiktokTitle, // Point 2a: Title field
      mode: tiktokMode,
      ...(coverImageUrl && { coverImageUrl }),
    };

    // Include Direct Post settings when in direct mode
    if (tiktokMode === 'direct') {
      body.privacyLevel = tiktokPrivacy;
      body.disableDuet = tiktokDisableDuet;
      body.disableStitch = tiktokDisableStitch;
      body.disableComment = tiktokDisableComment;
      // Commercial content disclosure
      if (tiktokCommercialToggle) {
        body.brandOrganicToggle = tiktokBrandOrganic;
        body.brandContentToggle = tiktokBrandContent;
      }
    }

    // Point 5e: Show publishing status
    setTiktokPostStatus('uploading');

    const result = await axios.post(
      `${baseUrl}/api/integrations/tiktok/publish`,
      body,
      { withCredentials: true, timeout: 60000 }
    );

    // Point 5e: Update status based on result
    const publishId = result.data?.publishId || result.data?.data?.publish_id;
    if (publishId && tiktokMode === 'direct') {
      setTiktokPostStatus('processing');
      // Poll publish status
      const pollStatus = async () => {
        try {
          const statusRes = await axios.get(
            `${baseUrl}/api/integrations/tiktok/publish-status?tenantId=${tenantId}&publishId=${publishId}`,
            { withCredentials: true }
          );
          const st = statusRes.data?.status;
          if (st === 'PUBLISH_COMPLETE') {
            setTiktokPostStatus('complete');
            toast.success('Your TikTok post has been published successfully!');
          } else if (st === 'FAILED') {
            setTiktokPostStatus('failed');
            toast.error('Your TikTok post failed to publish. Please try again.');
          } else {
            // Still processing, poll again
            setTimeout(pollStatus, 3000);
          }
        } catch {
          // Polling failed, show generic message
          setTiktokPostStatus(null);
        }
      };
      setTimeout(pollStatus, 3000);
    } else {
      setTiktokPostStatus(null);
    }

    // Point 5d: Notify user that content may take time to process
    if (tiktokMode === 'direct') {
      toast.info('Your TikTok post is being processed. It may take a few minutes for it to appear on your profile.');
    }

    return result;
  };

  // Handle editor save: MediaEditor uploads internally and returns the new URL
  const handleEditorSaved = (newUrl) => {
    const publicUrl = toPublic(newUrl);
    setEditedImages(prev => {
      const copy = [...prev];
      copy[editingImageIdx] = publicUrl;
      return copy;
    });
    setEditingImageIdx(null);
  };

  const submit = async () => {
    try {
      setBusy(true);
      setError("");

      if (!selected.length) throw new Error("Select at least one platform.");

      const tenantId = Number(tenant) || 1;

      // Check platform authorization before posting
      try {
        const statusRes = await fetch(
          `${baseUrl}/api/integrations/status/${tenantId}`,
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (statusRes.ok) {
          const statusData = await statusRes.json();
          if (statusData.success) {
            const statuses = statusData.integrations || {};
            const unauthorized = selected.filter(p => !statuses[p]?.connected);
            if (unauthorized.length) {
              const names = unauthorized.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(', ');
              toast.warn(`Please connect to ${names} before posting.`);
              navigate(`/${tenant}/integrations`);
              return;
            }
          }
        }
      } catch (err) {
        console.warn('[MediaPost] Could not verify platform authorization:', err.message);
      }

      // Build common payload for your hub route (others can accept video).
      // If the user converted images → video, post the generated video instead
      // of the underlying stills so platforms like TikTok / IG Reels / YouTube
      // Shorts get a clip rather than a carousel.
      let mediaUrlsForOthers = generatedVideoUrl
        ? unique([generatedVideoUrl, ...videosAbs])
        : unique([...videosAbs, ...effectiveImages]);

      // ---------- music-on-posts: wait for the mix and swap the video URL ----------
      let resolvedContent = content;
      let musicTiktokNative = false;
      if (musicAttachment?.id) {
        // Poll until the mix is ready (max ~60s)
        const deadline = Date.now() + 60_000;
        let attachment = null;
        while (Date.now() < deadline) {
          try {
            const { data } = await apiClient.get(`/music/attachment/${musicAttachment.id}`);
            attachment = data?.attachment || null;
          } catch (err) {
            console.warn('[MediaPost] music poll failed', err);
          }
          if (!attachment) break;
          if (attachment.mixed_file_status === 'ready' || attachment.mixed_file_status === 'failed') break;
          await new Promise(r => setTimeout(r, 2000));
        }
        if (!attachment) throw new Error('Music attachment lookup failed.');
        if (attachment.mixed_file_status === 'failed') {
          throw new Error(`Music mix failed: ${attachment.mix_error || 'unknown error'}`);
        }
        if (Number(attachment.tiktok_use_native_sound) === 1) {
          musicTiktokNative = true;
        }
        if (attachment.mixed_file_url && !musicTiktokNative) {
          // Swap the first video URL for the mixed file URL on every non-TikTok destination.
          mediaUrlsForOthers = mediaUrlsForOthers.map(u => isVideoUrl(u) ? toPublic(attachment.mixed_file_url) : u);
        }
        if (Number(attachment.attribution_required) && attachment.attribution_text
            && !resolvedContent.includes(attachment.attribution_text)) {
          resolvedContent = `${resolvedContent}${resolvedContent ? '\n\n' : ''}${attachment.attribution_text}`;
        }
      }

      // Detect on what we actually send
      const detected = detectKind(mediaUrlsForOthers);

      // Map kind → backend expectations. Instagram only publishes video as Reels
      // (the old VIDEO type is deprecated), so the toggle is really an FB-side
      // intent: 'reel' routes FB to /video_reels (Reels tab); anything else
      // routes FB to /videos (regular feed video). For IG the backend will
      // still auto-infer Reel from the .mp4 extension when kind is empty.
      const isVideoDetected = detected === "video" || detected === "mov";
      let inferredKind;
      if (detected === "image") {
        inferredKind = "image";
      } else if (isVideoDetected) {
        const choice = igPostKind === 'auto' ? 'reel' : igPostKind;
        inferredKind = choice === 'reel' ? 'reel' : '';
      } else {
        inferredKind = "";
      }

      // Instagram validations (format & connection)
      if (platforms.instagram) {
        await ensureIgReady(tenantId);

        // Only block MOV if it's NOT a local /public/... asset (server auto-transcodes locals)
        if (detected === "mov") {
          const first = mediaUrlsForOthers[0] || "";
          if (!isLocalPublic(first, baseUrl)) {
            throw new Error(
              "Instagram only accepts MP4 (H.264 + AAC). Convert your MOV to MP4 or upload it to this app (under /public) so we can auto-convert."
            );
          }
          // local MOV → allowed; backend will transcode
        }

        if (!mediaUrlsForOthers.length && !content.trim()) {
          throw new Error("Instagram requires at least one image/video or a caption.");
        }
      }

      // If multiple images selected, pass a simple carouselItems list
      const igCarousel = effectiveImages.length > 1
        ? effectiveImages.slice(0, 10).map((u) => ({ imageUrl: u }))
        : undefined;

      // TikTok Direct Post validation
      if (platforms.tiktok && tiktokMode === 'direct') {
        // Point 1b: Block posting when creator can't post more
        if (tiktokCreator?.cannotPostReason) {
          throw new Error("You've reached TikTok's posting limit. Please try again later.");
        }
        if (!tiktokPrivacy) throw new Error("Please select a privacy level for your TikTok post.");
        if (tiktokCommercialToggle && !tiktokBrandOrganic && !tiktokBrandContent) {
          throw new Error("You need to indicate if your content promotes yourself, a third party, or both.");
        }
        // Point 1c: Check video duration against creator max
        if (videosAbs.length > 0 && tiktokCreator?.maxVideoPostDurationSec) {
          const videoEl = document.querySelector('video');
          if (videoEl && videoEl.duration > tiktokCreator.maxVideoPostDurationSec) {
            throw new Error(`Video duration (${Math.round(videoEl.duration)}s) exceeds TikTok's maximum of ${tiktokCreator.maxVideoPostDurationSec}s for your account.`);
          }
        }
      }

      // Reddit validation
      if (platforms.reddit) {
        if (!redditSubreddit) throw new Error("Please select a subreddit for your Reddit post.");
        if (!redditTitle.trim()) throw new Error("Reddit posts require a title.");
      }

      // Remove platforms that are called directly from the hub list
      const platformsForHub = selected.filter(
        (p) => p !== "bluesky" && p !== "youtube" && p !== "twitter" && p !== "linkedin" && p !== "tiktok" && p !== "reddit"
      );

      const payloadCommon = {
        tenantId,
        eventId:    eventId ? Number(eventId) : null,
        eventItemId:itemId ? Number(itemId) : null,
        platforms:  platformsForHub,
        content:    resolvedContent,
        caption:    resolvedContent,
        mediaUrls:  mediaUrlsForOthers,
        kind: inferredKind,
        shareToFeed: inferredKind === 'reel' ? igShareReelToFeed : true,
        thumbOffsetSec: 0,
        carouselItems: igCarousel,
        musicDraftRef: musicAttachment?.id ? musicDraftRef.current : undefined,
        userTags: Object.keys(userTags).length > 0 ? userTags : undefined,
      };

      // 1) Others via hub
      if (payloadCommon.platforms.length) {
        // 5 min: a single IG reel publish can legitimately take
        // ffprobe + ffmpeg re-encode (up to ~30s for non-compliant
        // sources) + IG_POLL_MAX_MS (120s default) while IG processes
        // the video. The server-side per-platform budget
        // (INTEGRATIONS_PUBLISH_TIMEOUT_MS) is 180s; give the client
        // headroom above that so we don't abort a request that's
        // still actively succeeding.
        await axios.post(`${baseUrl}/api/integrations/publish`, payloadCommon, {
          withCredentials: true,
          timeout: 5 * 60 * 1000,
        });
      }

      // 2) Twitter directly (bypasses generic hub to avoid "Platform not implemented")
      if (platforms.twitter) {
        await publishToTwitter(tenantId, content || "", mediaUrlsForOthers);
      }

      // 3) LinkedIn directly
      if (platforms.linkedin) {
        await postToLinkedIn();
      }

      // 4) YouTube (videos only, uses server file paths)
      if (platforms.youtube) {
        await uploadToYouTube(tenantId);
      }

      // 5) Bluesky (images only, up to 4)
      if (platforms.bluesky) {
        if (!content.trim() && blueskyImages.length === 0) {
          throw new Error("Bluesky requires text or at least one image (video is not supported).");
        }
        await axios.post(
          `${baseUrl}/api/integrations/bluesky/publish`,
          { tenantId, text: content || "", mediaUrls: blueskyImages },
          { withCredentials: true, timeout: 60000 }
        );
      }

      // 6) TikTok (video or image to draft Inbox)
      if (platforms.tiktok) {
        await postToTikTok();
      }

      // 7) Reddit (requires subreddit + title)
      if (platforms.reddit) {
        const hasImage = imagesAbs.length > 0;
        const hasVideo = videosAbs.length > 0;

        let endpoint = '/api/integrations/reddit/publish-text';
        const redditBody = { tenantId, subreddit: redditSubreddit, title: redditTitle, text: content || '' };

        if (hasImage) {
          endpoint = '/api/integrations/reddit/publish-image-from-url';
          redditBody.imageUrl = imagesAbs[0];
        } else if (hasVideo) {
          endpoint = '/api/integrations/reddit/publish-video-from-url';
          redditBody.videoUrl = videosAbs[0];
        }

        await axios.post(`${baseUrl}${endpoint}`, redditBody, { withCredentials: true, timeout: 120000 });
      }

      navigate(-1);
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e.message ||
        "Failed to post";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  // Disable submit when TikTok commercial toggle is on but no sub-option selected
  const tiktokCommercialIncomplete = platforms.tiktok && tiktokMode === 'direct' &&
    tiktokCommercialToggle && !tiktokBrandOrganic && !tiktokBrandContent;
  // Disable submit when TikTok creator can't post (Point 1b)
  const tiktokCannotPost = platforms.tiktok && tiktokMode === 'direct' && tiktokCreator?.cannotPostReason;

  const canSubmit =
    selected.length > 0 &&
    (content.trim().length > 0 || effectiveImages.length > 0 || videosAbs.length > 0) &&
    !tiktokCommercialIncomplete &&
    !tiktokCannotPost;

  // ---------------- render ----------------
  return (
    <div className="container py-3">
      <h4 className="mb-3">Create Media Post</h4>

      {/* Integrations - Dropdown Selector */}
      <div className="mb-3">
        <div className="form-label font-semibold mb-2">Select Platforms</div>
        <PlatformSelector
          platforms={platforms}
          setPlatforms={setPlatforms}
          onConnect={(platformKey) => {
            if (platformKey === 'bluesky') {
              openBlueskyConnect();
            }
          }}
          showConnectFor={['bluesky']}
        />
      </div>

      {/* Content (with @mention autocomplete) */}
      <div className="mb-3">
        <label className="form-label">Post Content</label>
        <MentionInput
          value={content}
          onChange={setContent}
          rows={5}
          placeholder="Write your post... Type @ to mention a platform handle"
        />
        <div className="form-text">Type @ to mention platform handles (e.g. @nike, @caborojo)</div>
      </div>

      {/* Instagram / Facebook Reel options — only shown when at least one of
          IG/FB is selected AND a video is attached. */}
      {(platforms.instagram || platforms.facebook) && videosAbs.length > 0 && (
        <div className="mb-3 p-3 rounded" style={{ background: '#fdf2ff', border: '1px solid #C13584', color: '#212529' }}>
          <div className="font-semibold mb-2" style={{ color: '#C13584' }}>Instagram / Facebook Video Settings</div>
          <div className="mb-2">
            <label className="form-label small mb-1">Post Type</label>
            <select
              className="form-select"
              value={igPostKind}
              onChange={(e) => setIgPostKind(e.target.value)}
            >
              <option value="auto">Auto (Reel for video)</option>
              <option value="reel">Reel</option>
              <option value="feed">Feed Post</option>
            </select>
            <div className="form-text">
              Instagram always publishes video as a Reel. This toggle controls
              the Facebook Page placement: <em>Reel</em> uses the Reels tab,
              <em> Feed Post</em> uses regular Page video.
            </div>
          </div>
          {(igPostKind === 'auto' || igPostKind === 'reel') && (
            <div className="form-check form-switch">
              <input
                id="ig-share-reel-to-feed"
                className="form-check-input"
                type="checkbox"
                checked={igShareReelToFeed}
                onChange={(e) => setIgShareReelToFeed(e.target.checked)}
              />
              <label className="form-check-label small" htmlFor="ig-share-reel-to-feed">
                Share Reel to Instagram feed (in addition to Reels tab)
              </label>
            </div>
          )}
        </div>
      )}

      {/* Reddit-specific fields */}
      {platforms.reddit && (
        <div className="mb-3 p-3 rounded" style={{ background: '#fff4f0', border: '1px solid #FF4500' }}>
          <div className="font-semibold mb-2" style={{ color: '#FF4500' }}>Reddit Post Settings</div>
          <div className="mb-2">
            <label className="form-label small mb-1">Subreddit *</label>
            <select
              className="form-select"
              value={redditSubreddit}
              onChange={(e) => setRedditSubreddit(e.target.value)}
            >
              <option value="">Select a subreddit...</option>
              {redditSubreddits.map((sr) => (
                <option key={sr.name} value={sr.name}>r/{sr.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="form-label small mb-1">Post Title *</label>
            <input
              type="text"
              className="form-control"
              value={redditTitle}
              onChange={(e) => setRedditTitle(e.target.value)}
              placeholder="Enter a title for your Reddit post"
              maxLength={300}
            />
            <div className="form-text">{redditTitle.length}/300 characters</div>
          </div>
        </div>
      )}

      {/* TikTok-specific fields */}
      {platforms.tiktok && (
        <div className="mb-3 p-3 rounded" style={{ border: '1px solid var(--bs-border-color, #dee2e6)' }}>
          <div className="font-semibold mb-2">TikTok Post Settings</div>

          {/* Post Mode */}
          <div className="mb-2">
            <label className="form-label small mb-1">Post Mode</label>
            <select
              className="form-select"
              value={tiktokMode}
              onChange={(e) => setTiktokMode(e.target.value)}
              disabled={!tiktokIsDirect}
            >
              <option value="upload">Upload to Inbox (draft for review)</option>
              <option value="direct" disabled={!tiktokIsDirect}>Direct Post (publish immediately)</option>
            </select>
            {!tiktokIsDirect && (
              <div className="form-text">Direct Post requires TikTok app approval. Currently using Upload to Inbox.</div>
            )}
          </div>

          {/* Direct Post settings - only show when direct mode is selected */}
          {tiktokMode === 'direct' && (
            <>
              {/* === POINT 1: Creator Info === */}
              {/* Point 1a: Creator nickname */}
              {tiktokCreator?.nickname && (
                <div className="flex items-center gap-2 mb-2 p-2 rounded" style={{ border: '1px solid var(--bs-border-color, #dee2e6)' }}>
                  {tiktokCreator.avatarUrl && (
                    <img src={tiktokCreator.avatarUrl} alt="" style={{ width: 28, height: 28, borderRadius: '50%' }} />
                  )}
                  <span className="small">Posting as <strong>@{tiktokCreator.nickname}</strong></span>
                </div>
              )}

              {/* Point 1b: Block posting when creator can't post more */}
              {tiktokCreator?.cannotPostReason && (
                <div className="alert alert-danger py-2 mb-2" style={{ fontSize: '12px' }}>
                  <strong>Cannot post right now.</strong> {tiktokCreator.cannotPostReason}. Please try again later.
                </div>
              )}

              {/* Point 5a: Content preview */}
              {(videosAbs.length > 0 || imagesAbs.length > 0) && (
                <div className="mb-2">
                  <label className="form-label small mb-1">Content Preview</label>
                  <div className="flex gap-2 p-2 rounded" style={{ border: '1px solid var(--bs-border-color, #dee2e6)', background: 'var(--bs-tertiary-bg, #f8f9fa)', overflowX: 'auto' }}>
                    {videosAbs.length > 0 ? (
                      <video src={videosAbs[0]} style={{ maxHeight: 120, maxWidth: '100%', borderRadius: 4 }} controls muted />
                    ) : (
                      imagesAbs.slice(0, 4).map((img, i) => (
                        <img key={i} src={img} alt="" style={{ maxHeight: 120, borderRadius: 4, objectFit: 'cover' }} onError={(e) => (e.currentTarget.style.display = 'none')} />
                      ))
                    )}
                  </div>
                </div>
              )}

              {/* === POINT 2: Post Metadata === */}
              {/* Point 2a: Title */}
              <div className="mb-2">
                <label className="form-label small mb-1">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={tiktokTitle}
                  onChange={(e) => setTiktokTitle(e.target.value)}
                  placeholder="Enter a title for your TikTok post"
                  maxLength={150}
                />
                <div className="form-text">{tiktokTitle.length}/150 characters</div>
              </div>

              {/* Point 2b: Privacy Level - no default, options from creator_info */}
              <div className="mb-2">
                <label className="form-label small mb-1">Privacy Level *</label>
                <select
                  className="form-select"
                  value={tiktokPrivacy}
                  onChange={(e) => {
                    setTiktokPrivacy(e.target.value);
                    // Point 3b: If switching to private and branded content is on, disable it
                    if (e.target.value === 'SELF_ONLY' && tiktokBrandContent) {
                      setTiktokBrandContent(false);
                    }
                  }}
                  title={tiktokCommercialToggle && tiktokBrandContent ? 'Branded content visibility cannot be set to private.' : undefined}
                >
                  <option value="" disabled>Select privacy level...</option>
                  {(tiktokCreator?.privacyLevelOptions || ['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'SELF_ONLY']).map(opt => (
                    <option
                      key={opt}
                      value={opt}
                      disabled={opt === 'SELF_ONLY' && tiktokCommercialToggle && tiktokBrandContent}
                      title={opt === 'SELF_ONLY' && tiktokCommercialToggle && tiktokBrandContent ? 'Branded content visibility cannot be set to private.' : undefined}
                    >
                      {opt === 'PUBLIC_TO_EVERYONE' ? 'Public' : opt === 'MUTUAL_FOLLOW_FRIENDS' ? 'Friends Only' : opt === 'FOLLOWER_OF_CREATOR' ? 'Followers' : 'Private (Only Me)'}
                      {opt === 'SELF_ONLY' && tiktokCommercialToggle && tiktokBrandContent ? ' - unavailable for branded content' : ''}
                    </option>
                  ))}
                </select>
                {tiktokCommercialToggle && tiktokBrandContent && (
                  <div className="form-text text-yellow-500">Branded content visibility cannot be set to private.</div>
                )}
              </div>

              {/* Point 2c: Interaction Toggles - unchecked by default, grey out per creator settings */}
              <div className="mb-2">
                <label className="form-label small mb-1">Interaction Settings</label>
                <div className="flex flex-col gap-1">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="tiktok-mp-allow-comment"
                      checked={!tiktokDisableComment}
                      onChange={(e) => setTiktokDisableComment(!e.target.checked)}
                      disabled={tiktokCreator?.commentDisabled}
                    />
                    <label className="form-check-label small" htmlFor="tiktok-mp-allow-comment">
                      Allow Comments{tiktokCreator?.commentDisabled ? ' (disabled in your TikTok settings)' : ''}
                    </label>
                  </div>
                  {/* Duet and Stitch are not applicable to photo posts */}
                  {videosAbs.length > 0 && (
                    <>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="tiktok-mp-allow-duet"
                          checked={!tiktokDisableDuet}
                          onChange={(e) => setTiktokDisableDuet(!e.target.checked)}
                          disabled={tiktokCreator?.duetDisabled}
                        />
                        <label className="form-check-label small" htmlFor="tiktok-mp-allow-duet">
                          Allow Duet{tiktokCreator?.duetDisabled ? ' (disabled in your TikTok settings)' : ''}
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="tiktok-mp-allow-stitch"
                          checked={!tiktokDisableStitch}
                          onChange={(e) => setTiktokDisableStitch(!e.target.checked)}
                          disabled={tiktokCreator?.stitchDisabled}
                        />
                        <label className="form-check-label small" htmlFor="tiktok-mp-allow-stitch">
                          Allow Stitch{tiktokCreator?.stitchDisabled ? ' (disabled in your TikTok settings)' : ''}
                        </label>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* === POINT 3: Content Disclosure Setting === */}
              <div className="mb-2 p-2 rounded" style={{ border: '1px solid var(--bs-border-color, #dee2e6)', background: 'var(--bs-tertiary-bg, #f8f9fa)' }}>
                <div className="font-semibold small mb-1">Content Disclosure Setting</div>
                <div className="form-check form-switch mb-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="tiktok-mp-commercial"
                    checked={tiktokCommercialToggle}
                    onChange={(e) => {
                      setTiktokCommercialToggle(e.target.checked);
                      if (!e.target.checked) {
                        setTiktokBrandOrganic(false);
                        setTiktokBrandContent(false);
                      }
                    }}
                  />
                  <label className="form-check-label small" htmlFor="tiktok-mp-commercial">
                    This {videosAbs.length > 0 ? 'video' : 'photo'} promotes yourself, a brand, a product, or a service
                  </label>
                </div>
                <div className="form-text">Turn this on if your content is commercial in nature.</div>

                {tiktokCommercialToggle && (
                  <div
                    className="ml-3 mt-2 p-2 rounded"
                    style={{ border: '1px dashed var(--bs-border-color, #dee2e6)' }}
                    title={!tiktokBrandOrganic && !tiktokBrandContent ? 'You need to indicate if your content promotes yourself, a third party, or both.' : undefined}
                  >
                    <div className="small font-semibold mb-1">You must select at least one of the options below:</div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="tiktok-mp-brand-organic"
                        checked={tiktokBrandOrganic}
                        onChange={(e) => setTiktokBrandOrganic(e.target.checked)}
                      />
                      <label className="form-check-label small" htmlFor="tiktok-mp-brand-organic">
                        <strong>Your Brand</strong> — I am promoting myself or my own business
                      </label>
                    </div>

                    <div className="form-check mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="tiktok-mp-brand-content"
                        checked={tiktokBrandContent}
                        onChange={(e) => {
                          setTiktokBrandContent(e.target.checked);
                          // Point 3b: Branded content can't be private
                          if (e.target.checked && tiktokPrivacy === 'SELF_ONLY') {
                            setTiktokPrivacy('PUBLIC_TO_EVERYONE');
                          }
                        }}
                        disabled={tiktokPrivacy === 'SELF_ONLY'}
                        title={tiktokPrivacy === 'SELF_ONLY' ? 'Branded content visibility cannot be set to private.' : undefined}
                      />
                      <label className="form-check-label small" htmlFor="tiktok-mp-brand-content">
                        <strong>Branded Content</strong> — I am promoting another brand or a third party
                        {tiktokPrivacy === 'SELF_ONLY' ? ' (unavailable when privacy is Private)' : ''}
                      </label>
                    </div>

                    {/* Point 3a: Label preview based on selection */}
                    {tiktokBrandOrganic && !tiktokBrandContent && (
                      <div className="alert alert-info py-1 mt-2 mb-0" style={{ fontSize: '12px' }}>
                        Your {videosAbs.length > 0 ? 'video' : 'photo'} will be labeled as &quot;Promotional content&quot;
                      </div>
                    )}
                    {tiktokBrandContent && (
                      <div className="alert alert-info py-1 mt-2 mb-0" style={{ fontSize: '12px' }}>
                        Your {videosAbs.length > 0 ? 'video' : 'photo'} will be labeled as &quot;Paid partnership&quot;
                      </div>
                    )}

                    {/* Validation: at least one must be selected */}
                    {!tiktokBrandOrganic && !tiktokBrandContent && (
                      <div className="alert alert-danger py-1 mt-2 mb-0" style={{ fontSize: '12px' }}>
                        You need to indicate if your content promotes yourself, a third party, or both.
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* === POINT 4: Consent declaration === */}
              <div className="alert alert-warning py-2 mb-2" style={{ fontSize: '12px' }}>
                By posting, you agree to TikTok's{' '}
                {tiktokCommercialToggle && (tiktokBrandContent) && (
                  <><a href="https://www.tiktok.com/legal/page/row/bc-policy" target="_blank" rel="noopener noreferrer">Branded Content Policy</a> and{' '}</>
                )}
                <a href="https://www.tiktok.com/legal/page/row/music-usage-confirmation" target="_blank" rel="noopener noreferrer">Music Usage Confirmation</a>.
              </div>

              {/* === POINT 5e: Publish status indicator === */}
              {tiktokPostStatus && (
                <div className={`alert py-2 mb-0 ${tiktokPostStatus === 'failed' ? 'alert-danger' : tiktokPostStatus === 'complete' ? 'alert-success' : 'alert-info'}`} style={{ fontSize: '12px' }}>
                  {tiktokPostStatus === 'uploading' && <><FaSpinner className="spinner-border spinner-border-sm mr-1" /> Uploading content to TikTok...</>}
                  {tiktokPostStatus === 'processing' && <><FaSpinner className="spinner-border spinner-border-sm mr-1" /> TikTok is processing your post...</>}
                  {tiktokPostStatus === 'complete' && 'Your post has been published to TikTok!'}
                  {tiktokPostStatus === 'failed' && 'Failed to publish to TikTok. Please try again.'}
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* Images (with text overlay option) */}
      <div className="mb-3">
        <div className="form-label" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <span>Images:</span>
          {effectiveImages.length > 0 && !generatedVideoUrl && (
            <>
              <label className="small" style={{ marginLeft: 8 }}>
                Sec/image:{' '}
                <input
                  type="number"
                  min={1}
                  max={15}
                  value={imgToVideoSeconds}
                  onChange={(e) => setImgToVideoSeconds(Number(e.target.value) || 4)}
                  style={{ width: 60, padding: '2px 6px' }}
                />
              </label>
              <button
                type="button"
                onClick={handleConvertToVideo}
                disabled={convertingToVideo}
                className="btn"
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  padding: '4px 10px', fontSize: 13,
                  border: '1px solid #ff6800', background: 'transparent', color: '#ff6800',
                  borderRadius: 6, cursor: 'pointer',
                }}
                title="Render these images into an MP4 slideshow for video-first platforms"
              >
                {convertingToVideo ? <FaSpinner /> : <FaFilm />}
                {convertingToVideo ? 'Converting…' : 'Convert to Video'}
              </button>
            </>
          )}
          {generatedVideoUrl && (
            <button
              type="button"
              onClick={handleRevertToImages}
              className="btn"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                padding: '4px 10px', fontSize: 13,
                border: '1px solid #6c757d', background: 'transparent', color: '#6c757d',
                borderRadius: 6, cursor: 'pointer',
              }}
            >
              Use images instead
            </button>
          )}
        </div>

        {generatedVideoUrl && (
          <div className="alert alert-info" style={{ marginBottom: 8 }}>
            <FaFilm /> Posting the rendered slideshow instead of the still images.
            <video src={generatedVideoUrl} controls style={{ width: '100%', marginTop: 8, borderRadius: 6 }} />
          </div>
        )}

        {effectiveImages.length === 0 ? (
          <div className="text-gray-400">No images provided.</div>
        ) : (
          <>
            {/* HERO (full-width, responsive). Tap to open full-size for tagging. */}
            <div
              className="border rounded mb-2"
              style={{
                width: "100%",
                maxWidth: "100%",
                background: "#111",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <MediaTagOverlay
                src={effectiveImages[0]}
                tags={userTags[0] || []}
                disabled
                onTap={() => setFullSizeImgIdx(0)}
                style={{ width: "100%" }}
                objectFit="contain"
                onError={(e) => (e.currentTarget.src = "/event.png")}
              />
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setEditingImageIdx(0); }}
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  background: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "6px 12px",
                  fontSize: 13,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  zIndex: 3,
                }}
                title="Edit image"
              >
                <FaEdit /> Edit
              </button>
            </div>

            {/* Thumbnails (if more than one) */}
            {effectiveImages.length > 1 && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fill, minmax(160px, 1fr))",
                  gap: 10,
                }}
              >
                {effectiveImages.slice(1).map((u, i) => {
                  const imgIdx = i + 1;
                  return (
                    <div
                      key={u}
                      className="border rounded overflow-hidden"
                      style={{ aspectRatio: "4 / 3", background: "#111", position: "relative" }}
                    >
                      <MediaTagOverlay
                        src={u}
                        tags={userTags[imgIdx] || []}
                        disabled
                        onTap={() => setFullSizeImgIdx(imgIdx)}
                        style={{ width: "100%", height: "100%" }}
                        objectFit="cover"
                        onError={(e) => (e.currentTarget.src = "/event.png")}
                      />
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setEditingImageIdx(imgIdx); }}
                        style={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          background: "rgba(0,0,0,0.6)",
                          color: "#fff",
                          border: "none",
                          borderRadius: 4,
                          padding: "3px 8px",
                          fontSize: 11,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          zIndex: 3,
                        }}
                        title="Edit image"
                      >
                        <FaEdit />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}

        {/* Bluesky hint */}
        {platforms.bluesky && blueskyImages.length === 0 && !content.trim() && (
          <div className="form-text mt-2">
            Bluesky supports images (no video). Add at least one image or include
            text.
          </div>
        )}
      </div>

      {/* Image Editor */}
      {editingImageIdx !== null && effectiveImages[editingImageIdx] && (
        <MediaEditor
          src={effectiveImages[editingImageIdx]}
          tenantId={Number(tenant) || 1}
          eventId={eventId ? Number(eventId) : null}
          onSaved={handleEditorSaved}
          onClose={() => setEditingImageIdx(null)}
        />
      )}

      {/* Full-size media viewer for tagging */}
      {fullSizeImgIdx !== null && effectiveImages[fullSizeImgIdx] && (
        <FullSizeMediaModal
          src={effectiveImages[fullSizeImgIdx]}
          tags={userTags[fullSizeImgIdx] || []}
          onChange={(tags) => setUserTags(prev => ({ ...prev, [fullSizeImgIdx]: tags }))}
          onClose={() => setFullSizeImgIdx(null)}
        />
      )}

      {/* Videos */}
      {!!videosAbs.length && (
        <div className="mb-3">
          {/* <div className="form-label">
            Videos (for Instagram/Twitter/LinkedIn/YouTube):
          </div>
          <div className="text-gray-400" style={{ fontSize: 13 }}>
            YouTube uploads require local files under <code>/public</code>.
            External URLs are skipped.
          </div> */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
              gap: 12,
              marginTop: 8,
            }}
          >
            {videosAbs.map((u, i) => (
              <video key={i} src={u} controls style={{ width: "100%" }} />
            ))}
          </div>
        </div>
      )}

      {!!error && <div className="alert alert-danger">{error}</div>}

      {/* Music attachment chip */}
      {musicAttachment && (
        <div style={{
          margin: '8px 0', padding: '8px 12px', background: '#1a2240', color: '#fff',
          borderRadius: 6, display: 'flex', alignItems: 'center', gap: 10, fontSize: 13,
        }}>
          <FaMusic style={{ color: '#ff6800' }} />
          <span>
            {musicAttachment.tiktokUseNativeSound
              ? 'TikTok native sound (chosen in-app)'
              : `"${musicAttachment.track?.title}" by ${musicAttachment.track?.artist || 'Unknown'}`}
          </span>
          <button type="button" onClick={() => setMusicPickerOpen(true)} style={{
            marginLeft: 'auto', padding: '2px 10px', background: 'transparent',
            color: '#fff', border: '1px solid #5a6a9a', borderRadius: 4, cursor: 'pointer',
          }}>Change</button>
          <button type="button" onClick={removeMusic} style={{
            padding: '2px 10px', background: 'transparent', color: '#ff8e8e',
            border: '1px solid #7a3a3a', borderRadius: 4, cursor: 'pointer',
          }}>Remove</button>
        </div>
      )}

      {/* Desktop inline action bar (replaces footer on desktop) */}
      <div className="desktop-action-bar">
        <button type="button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
        <button
          type="button"
          onClick={() => setMusicPickerOpen(true)}
          title="Add music to this post (requires a video)"
        >
          <FaMusic style={{ color: '#fff' }} /> {musicAttachment ? 'Edit music' : 'Add music'}
        </button>
        <button
          type="button"
          className="btn-primary-action"
          onClick={submit}
          disabled={busy || !canSubmit}
          title={
            tiktokCommercialIncomplete
              ? "You need to indicate if your content promotes yourself, a third party, or both."
              : tiktokCannotPost
              ? "You've reached TikTok's posting limit. Please try again later."
              : undefined
          }
        >
          <FaPaperPlane /> {busy ? "Posting…" : "Submit"}
        </button>
      </div>

      <MusicPicker
        open={musicPickerOpen}
        onClose={() => setMusicPickerOpen(false)}
        draftRef={musicDraftRef.current}
        sourceVideoUrl={videosAbs[0] || ''}
        selectedPlatforms={Object.keys(platforms).filter(k => platforms[k])}
        currentAttachmentId={musicAttachment?.id}
        onAttached={handleMusicAttached}
      />

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          {
            icon: <FaMusic style={{ color: '#fff' }} />,
            label: musicAttachment ? "Edit music" : "Add music",
            onClick: () => setMusicPickerOpen(true),
          },
          {
            icon: <FaPaperPlane />,
            label: busy ? "Posting…" : "Submit",
            onClick: submit,
            disabled: busy || !canSubmit,
            type: "submit",
          },
        ]}
      />
    </div>
  );
}